import type { TOC } from '@ember/component/template-only';
import { local } from 'embroider-css-modules';

import styles from '../checklist.module.css';
import PrismIcon from '../icon.gts';

interface PrismChecklistItemSignature {
  Args: {
    isChecked?: boolean;
    label?: string;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLLIElement;
}

const PrismChecklistItem = <template>
  <li
    class={{styles.list-item}}
    data-test-id="prism-checklist-item"
    ...attributes
  >
    <div
      class={{local styles "icon" (if @isChecked "is-checked")}}
      data-test-id="prism-checklist-check-icon"
    >
      <PrismIcon @color="inherit" @name="circle-checkmark" @size="small" />
    </div>

    <p class={{styles.content}}>
      {{#if @label}}
        {{@label}}
      {{else}}
        {{yield}}
      {{/if}}
    </p>
  </li>
</template> satisfies TOC<PrismChecklistItemSignature>;

export default PrismChecklistItem;
